/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import isEmpty from 'lodash/isEmpty';

export const getCommTourList = (tourList) =>
    tourList.filter((tour) => tour.is_commercial_quota);

export const getNonCommTourList = (tourList) =>
    tourList.filter((tour) => !tour.is_commercial_quota);

export const isAccountAllowed = (isCommAccount, tourData) =>
    !isEmpty(tourData) &&
    ((isCommAccount && tourData.is_commercial_quota) ||
        (!isCommAccount && !tourData.is_commercial_quota));
